import React, {useState} from "react"

import Loading from "@irati/ui/src/Loading"
import {FormattedMessage} from "@irati/utils/lang"
import {User} from "@irati/types"

import Flex from "@irati/ui/src/Flex"
import {Body, H3} from "@irati/ui/src/Typography"
import Alert, {AlertTypes} from "@irati/ui/src/Alert"
import Spacing from "@irati/ui/src/Spacing"
import ValidationButton from "@irati/ui/src/FormItem/ValidationButton"

import EditFailedUser from "../EditFailedUser/EditFailedUser"

interface Props {
  added: User[]
  notAdded: User[]
  headers: string[]
  handleCreate: (user: User) => void
  gotoSuccess: () => void
  removeUser: (user: User, cb: () => void) => void
}

const EditUsersFailed: React.FC<Props> = ({added, notAdded, headers, removeUser, gotoSuccess, handleCreate}) => {
  const [load, setLoad] = useState<Promise<any> | null>(null)
  const [successAlert, setSuccessAlert] = useState(true)
  const [errorAlert, setErrorAlert] = useState(true)

  const handleRemoveUser = (user: User) => {
    removeUser(user, () => {
      if (notAdded.length === 0) {
        gotoSuccess()
      }
    })
  }

  const submitFailedUsers = () => {
    const adding = [...notAdded].map((user) => handleCreate(user))
    const loaded = Promise.all(adding).then(() => {
      setLoad(null)
      if (notAdded.length === 0) {
        gotoSuccess()
      }
    })
    setLoad(loaded)
  }

  return (
    <Spacing marginTop>
      {successAlert && added.length > 0 && (
        <Alert
          type={AlertTypes.success}
          title="admin.containers.editPeopleFailed.alert.success"
          values={{added: added.length}}
          onHide={() => setSuccessAlert(false)}
        />
      )}
      {errorAlert && notAdded.length > 0 && (
        <Alert
          type={AlertTypes.error}
          title="admin.containers.editPeopleFailed.alert.error"
          values={{notAdded: notAdded.length}}
          onHide={() => setErrorAlert(false)}
        />
      )}
      <Flex marginTop={2} marginBottom={3} gap={2}>
        <Flex direction="column">
          <H3 marginBottom maxWidth="100%">
            <FormattedMessage id="admin.containers.editPeopleFailed.header" />
          </H3>
          <Body maxWidth="100%">
            <FormattedMessage id="admin.containers.editPeopleFailed.text" />
          </Body>
        </Flex>
        <Flex width="30%" justifyContent="flex-end" alignSelf="baseline">
          <ValidationButton primary load={load} onClick={submitFailedUsers} disabled={notAdded.length === 0}>
            <FormattedMessage id="admin.containers.editPeopleFailed.save" />
          </ValidationButton>
        </Flex>
      </Flex>
      <Loading load={load}>
        {notAdded.map((user) => (
          <EditFailedUser key={user.email} user={user} removeUser={handleRemoveUser} headers={headers} />
        ))}
      </Loading>
    </Spacing>
  )
}

export default EditUsersFailed
